import React, { useEffect } from "react";
import TopHeader from "../../components/TopHeader";
import NavigationBarStudentLanding from "../../components/NavigationBarStudentLanding";
import BulkEnroll from "../../components/student-dashboard/add_learner";
import Footer from "../../components/Footer";
import { useParams } from 'react-router-dom';

function BulkLearnerEnroll() {
  let { id, type } = useParams();
  return (
    <>
      <TopHeader />
      <NavigationBarStudentLanding />
      <BulkEnroll id={id} type={type} />
      <Footer />
    </>
  );
}

export default BulkLearnerEnroll;
